import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listUserSessions } from "../api";

export default function SessionsList() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await listUserSessions();
        // setSessions(data?.sessions || data?.items || []);
        // setSessions(data|| []);
        setSessions(data|| []);
      } catch (e) {
        console.error("Failed to load sessions", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-[80px] px-4 md:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-gray-800">My Sessions</h1>
          <Link
            to="/"
            className="text-sm text-blue-600 hover:text-blue-700 font-semibold"
          >
            Explore Agents
          </Link>
        </div>

        {loading && (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600"></div>
          </div>
        )}

        {!loading && sessions.length === 0 && (
          <div className="bg-white rounded-lg shadow-sm p-6 text-center text-gray-600">
            No sessions yet. Start by selecting an analyst.
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {sessions.map((s) => (
            <Link
              key={s.session_id || s.id}
              to={`/conversation/${s.session_id || s.id}`}
              className="block bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-4"
            >
              <div className="flex flex-col gap-1">
                <div className="text-gray-900 font-semibold truncate">
                  {s.session_name || s.agent_name || "Session"}
                </div>
                <div className="text-xs text-gray-600">
                  {s.agent_name ? `Agent: ${s.agent_name}` : null}
                </div>
                <div className="text-xs text-gray-500">
                  {s.created_at ? new Date(s.created_at).toLocaleString() : ""}
                </div>
                {s.pdf_count != null && (
                  <div className="text-xs text-gray-500">PDFs: {s.pdf_count}</div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}


